<template>
  <v-client-table
    :data="data.typeFormatPresseLignes"
    :columns="columns" :options="options"
    class="column is-12 displayNoneVuePagination"
    ref="tableTypeFormatPresseLignes">
  </v-client-table>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';

export default {
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
  computed: {
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          'emplacement.libelle': this.$t('listeTypeFormatPresse.childrow.emplacement'),
          'surface.libelle': this.$t('listeTypeFormatPresse.childrow.surface'),
          'couleurEncart.libelle': this.$t('listeTypeFormatPresse.childrow.couleur'),
          sens: this.$t('listeTypeFormatPresse.childrow.sens'),
          largeur: this.$t('listeTypeFormatPresse.childrow.largeur'),
          hauteur: this.$t('listeTypeFormatPresse.childrow.hauteur'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        sortable: ['emplacement.libelle', 'surface.libelle', 'couleurEncart.libelle', 'largeur', 'hauteur', 'sens'],
      };
    },
    columns() {
      return ['emplacement.libelle', 'surface.libelle', 'couleurEncart.libelle', 'largeur', 'hauteur', 'sens'];
    },
  },
};

</script>
